import React, {useRef, useState} from 'react';
import Draggable, {DraggableData, DraggableEvent} from 'react-draggable';
import {Modal} from "shared/ui";
import {ModalProps} from "./modal";

export const DraggableModal = (props: ModalProps) => {
  const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
  const draggleRef = useRef<HTMLDivElement>(null!);
  
  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const {clientWidth, clientHeight} = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };
  
  return (<Modal
    open
    maskClosable
    centered
    {...props}
    modalRender={(modal) => (<Draggable
      disabled={false}
      bounds={bounds}
      nodeRef={draggleRef}
      onStart={(event, uiData) => onStart(event, uiData)}
    >
      <div ref={draggleRef}>{modal}</div>
    </Draggable>)} />);
}
